<aside 
    id="small-sidebar" 
    class="sidebar fixed top-0 left-0 z-20 w-18 h-screen"
    aria-label="Sidebar"
>
    <div class="h-minus-4 ml-4 shadow-custom-1 rounded-b-lg p-4 overflow-y-auto bg-white border-r border-gray-300">
        <div id="small-sidebar-content">
            <ul class="space-y-2">
                <li>
                    <button 
                        (click)="navigateToPage('')"
                        data-tooltip-target="tooltip-dashboard" data-tooltip-placement="right"routerLink=""
                        class="h-[44px] flex flex-row items-center p-2 rounded-md hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === '' || pageRoute == 'dashboard'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.LayoutDashboard"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-dashboard" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Dashboard
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button  
                        (click)="navigateToPage('evaluations')"
                        data-tooltip-target="tooltip-evaluations" data-tooltip-placement="right"
                        class="h-[44px] flex items-center w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'evaluations'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.FileUser"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-evaluations" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Evaluations
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button  
                        (click)="navigateToPage('assessments')"
                        data-tooltip-target="tooltip-assessments" data-tooltip-placement="right"
                        class="h-[44px] flex items-center w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'assessments'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.ClipboardList"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-assessments" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Assessments
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('plans')"
                        data-tooltip-target="tooltip-plans" data-tooltip-placement="right"
                        class="h-[44px] flex items-start w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'plans'}">
                        <div class="w-6 pt-1">
                            <lucide-icon [img]="icons.NotepadText"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-plans" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Plans
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('interventions')"
                        data-tooltip-target="tooltip-intervention" data-tooltip-placement="right"
                        class="h-[44px] flex items-start w-full p-2 transition duration-75 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'interventions'}">
                        <div class="w-6 pt-1">
                            <lucide-icon [img]="icons.ShieldAlert"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-intervention" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Interventions
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('monitoring')"
                        data-tooltip-target="tooltip-monitoring" data-tooltip-placement="right"
                        class="h-[44px] flex flex-row items-center p-2 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'monitoring'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.Target"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-monitoring" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Monitoring
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
                <li class="group">
                    <button 
                        (click)="navigateToPage('closed')"
                        data-tooltip-target="tooltip-closed" data-tooltip-placement="right"
                        class="h-[44px] flex flex-row items-center p-2 rounded-md group-hover:text-nside-orange-400 cursor-pointer"
                        [ngClass]="{'text-nside-orange-400': pageRoute === 'closed'}">
                        <div class="w-6">
                            <lucide-icon [img]="icons.ClipboardCheck"></lucide-icon>
                        </div>
                    </button>
                    <div id="tooltip-closed" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                        Closed
                        <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </li>
            </ul>
            <div class="mx-4 h-[2px] bg-gray-200"></div>
        </div>
    </div>
    <div 
        (click)="$event.preventDefault(); toggleSidebar();"
        id="toggle-back-btn" 
        class="absolute top-6 -right-6 py-3 bg-white border-r border-gray-300 cursor-pointer shadow-custom-1"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right"><path d="m9 18 6-6-6-6"/></svg>
    </div>
</aside>
